import { ServiceConfig } from '../services/config'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ICompanySetup } from './typings'
import { get } from '../services/crud'

const url = `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.company}`

export const getCompanySetup = createAsyncThunk<
  ICompanySetup,
  void,
  { rejectValue: string }
>('companySetup/get', async (_, thunkApi) => {
  const response = await get(`${url}`)
  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})
